module.exports = {
          srcSet: __webpack_public_path__ + "7addd315a076bad5a6b64502c8c68241-906.png"+" 906w",
          images:[ {path: __webpack_public_path__ + "7addd315a076bad5a6b64502c8c68241-906.png",width: 906,height: 224}],
          src: __webpack_public_path__ + "7addd315a076bad5a6b64502c8c68241-906.png",
          toString:function(){return __webpack_public_path__ + "7addd315a076bad5a6b64502c8c68241-906.png"},
          
          width: 906,
          height: 224
        }